import { userService } from '../../helpers/fakebackend/user.service';
import router from '../../router/index'

// Parse robusto: si no es JSON válido, úsalo tal cual como string
function getStoredUser() {
  const raw = localStorage.getItem('user')
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    // si era texto plano (ej: "d.rodriguez@..."), devuélvelo como objeto mínimo
    return typeof raw === 'string' ? { email: raw } : raw
  }
}

const user = getStoredUser()

export const state = user
  ? { status: { loggeduser: true }, user }
  : { status: {}, user: null };
